<template>
  <router-link :to="{ path: link_to }" style="text-decoration: none; color: inherit">
    <!-- <el-badge :value="12" :max="99" class="item"> -->
    <el-card shadow="hover">
      <div class="card-content">
        <div class="icon-wrapper">
          <el-icon v-if="type== 1">
            <List />
          </el-icon>
          <el-icon v-else-if="type== 3">
            <Operation />
          </el-icon>
          <el-icon v-else-if="type== 2">
            <Setting />
          </el-icon>
          <el-icon v-else-if="type== 9">
            <Edit />
          </el-icon>
          <el-icon v-else-if="type== 6">
            <PieChart />
          </el-icon>
          <el-icon v-else>
            <Document />
          </el-icon>
        </div>
        <div class="text-wrapper">
          <span class="card-text">{{ text }}</span>
        </div>
      </div>
    </el-card>
    <!-- </el-badge> -->
  </router-link>
</template>

<script>
import { Document, Setting, Edit, Operation, List, PieChart } from '@element-plus/icons'
import { computed } from 'vue'
export default {
  name: "NavigationIcon",
  components: {
    Document, Setting, Edit, Operation, List, PieChart
  },
  setup(props) {
    const link_to = computed(() => {
      if (props.type == 1) {
        return props.url
      }
      else if (props.type == 9) {
        return "/misc" + props.url
      }
      else if (props.type == 3) {
        return props.url
      }
      else if (props.type == 2) {
        return "/functions" + props.url
      }
      else if (props.type == 3) {
        return "/reports" + props.url
      }
      else if (props.type == 4) {
        return "/imports" + props.url
      }
      else if (props.type == 5) {
        return "/exports" + props.url
      }
      else if (props.type == 6) {
        return "/r/" + props.url
      }
      return ""
    })
    return { link_to }
  },
  props: {
    url: String,
    text: String,
    icon: String,
    type: Number
  },
  data: () => ({}),
  created() { },
};
</script>

<style scoped>
a {
  display: block;
  width: 110px;
  height: 110px;
  border-radius: 8px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  flex-shrink: 0;
}

a:hover {
  transform: translateY(-4px);
}

a:active {
  transform: translateY(-2px);
}

.el-card {
  width: 100%;
  height: 100%;
  background-color: #8eb4d129 !important;
  border-radius: 8px;
  border: 1px solid rgba(142, 180, 209, 0.2);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.el-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(142, 180, 209, 0.1) 0%, rgba(82, 145, 194, 0.05) 100%);
  opacity: 0;
  transition: opacity 0.3s ease;
  pointer-events: none;
  z-index: 0;
}

.el-card:hover {
  background-color: #5291c229 !important;
  border-color: rgba(82, 145, 194, 0.4);
  box-shadow: 0 4px 12px rgba(82, 145, 194, 0.15);
}

.el-card:hover::before {
  opacity: 1;
}

.el-card:active {
  transform: scale(0.98);
}

.el-card :deep(.el-card__body) {
  width: 100%;
  height: 100%;
  padding: 0 !important;
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.card-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px;
}

.icon-wrapper {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.el-icon {
  font-size: 2.2em;
  width: 1em;
  height: 1em;
  transition: transform 0.3s ease, color 0.3s ease;
  color: #334762;
  display: flex;
  align-items: center;
  justify-content: center;
}

.el-card:hover .el-icon {
  transform: scale(1.1);
  color: #5291c2;
}

.text-wrapper {
  text-align: center;
}

.card-text {
  font-size: 0.7rem;
  font-weight: bold;
  line-height: 1.2;
  word-wrap: break-word;
  overflow-wrap: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: color 0.3s ease;
}

.el-card:hover .card-text {
  color: #334762;
}

.el-badge {
  margin-top: 10px;
}
</style>
